<script setup>
import { useTheme } from 'vuetify'
import ScrollToTop from '@core/components/ScrollToTop.vue'
import initCore from '@core/initCore'
import {
  initConfigStore,
  useConfigStore,
} from '@core/stores/config'
import { hexToRgb } from '@core/utils/colorConverter'

import { useSnackbar } from '@/composables/useSnackbar'

import { computed } from 'vue'

const { snackbar, hideSnackbar } = useSnackbar()

const { global } = useTheme()


// NOTE: Sync current theme with initial loader theme
initCore()
initConfigStore()

const isAuthenticated = computed(() => {
  const token = useCookie('accessToken').value

  return !!token
})

const configStore = useConfigStore()
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- NOTE: This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />
      <ScrollToTop />

    </VApp>
  </VLocaleProvider>
  <!-- Global Snackbar -->
  <VSnackbar
    v-model="snackbar.show"
    :color="snackbar.color"
    :timeout="snackbar.timeout"
    location="bottom right"
  >
    {{ snackbar.text }}

    <template #actions>
      <VBtn
        icon="tabler-x"
        variant="text"
        size="small"
        @click="hideSnackbar"
      />
    </template>
  </VSnackbar>
</template>
